import { render, staticRenderFns } from "./TemplateBind.vue?vue&type=template&id=0b6d004b&scoped=true"
import script from "./TemplateBind.vue?vue&type=script&lang=js"
export * from "./TemplateBind.vue?vue&type=script&lang=js"
import style0 from "./TemplateBind.vue?vue&type=style&index=0&id=0b6d004b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6d004b",
  null
  
)

export default component.exports